module.exports = __webpack_public_path__ + "static/img/bcg.4b9ffbec.webp";